import request from '../../../common/RemoteApiService';

const baseUrl = window.voucherManagementConfig.api.baseUrl;
const endpoints = window.voucherManagementConfig.api.endpoints;

export const getAll = async (merchantUuid, page) => {
  const response = await request('GET', endpoints.vouchers.getAll(baseUrl, merchantUuid, page), null, {
    credentials: 'include',
  });

  return response.json();
};

export const get = async (merchantUuid, uuid) => {
  const response = await request('GET', endpoints.vouchers.get(baseUrl, merchantUuid, uuid), null, {
    credentials: 'include',
  });

  return response.json();
};

export async function remove(merchantUuid, voucher) {
  await request('DELETE', endpoints.vouchers.delete(baseUrl, merchantUuid, voucher.uuid), null, {
    credentials: 'include',
  });
}
export async function create(merchantUuid, voucher) {
  await request('POST', endpoints.vouchers.create(baseUrl, merchantUuid), voucher, {
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json'
    }
  });
};
export async function update(merchantUuid, voucher) {
  await request('PATCH', endpoints.vouchers.update(baseUrl, merchantUuid, voucher.uuid), voucher, {
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json'
    }
  });
}

export async function createOrUpdate(merchantUuid, voucher) {
  if (voucher.uuid) {
    return update(merchantUuid, voucher);
  }

  return create(merchantUuid, voucher);
}
export async function searchTags(tagString, query) {
  const response = await request('GET', endpoints.tags.search(baseUrl, tagString, query), null, {
    credentials: 'include',
  });

  return response.json();
}
